import React from 'react';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function EducationForm({ shopType, formState, setFormState }) {
 const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  const handleCheckboxChange = (key, value) => {
    setFormState(key, value);
  };

  const learningModes = ['Online', 'In-person', 'Hybrid'];

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* Schools / Tutoring Centers */}
      {subtype === 'ED_schools' && (
        <>
          <div className="field">
            <label className="mr-2">School subtype</label>
            <InputText
              value={formState[`schoolsubtype_${subtype}`] || ''}
              onChange={(e) => setFormState(`schoolsubtype_${subtype}`, e.target.value)}
              placeholder="e.g. Primary, Secondary, Special Education"
            />
          </div>

          <div className="field">
            <label>Subjects Offered</label>
            <InputText
              value={formState[`subjectsOffered_${subtype}`] || ''}
              onChange={(e) => setFormState(`subjectsOffered_${subtype}`, e.target.value)}
              placeholder="e.g. Math, Science, History"
            />
          </div>

          <div className="field">
            <label>Age Group</label>
            <InputText
              value={formState[`ageGroup_${subtype}`] || ''}
              onChange={(e) => setFormState(`ageGroup_${subtype}`, e.target.value)}
              placeholder="e.g. Kids, Teens, Adults"
            />
          </div>

          <div className="field">
            <label>Location</label>
            <InputText
              value={formState[`location_${subtype}`] || ''}
              onChange={(e) => setFormState(`location_${subtype}`, e.target.value)}
              placeholder="e.g. Metro Manila, Davao"
            />
          </div>
        </>
      )}

      {/* Online Courses */}
      {subtype === 'ED_onlineCourses' && (
        <>
          <div className="field">
            <label className="mr-2">Course Duration (hrs)</label>
            <InputNumber
              value={formState[`courseDuration_${subtype}`] || 0}
              onValueChange={(e) => setFormState(`courseDuration_${subtype}`, e.value)}
              placeholder="e.g. 30 hours, 50 hours"
            />
          </div>

          <div className="field">
            <label>Platform</label>
            <InputText
              value={formState[`platform_${subtype}`] || ''}
              onChange={(e) => setFormState(`platform_${subtype}`, e.target.value)}
              placeholder="e.g. Udemy, Coursera"
            />
          </div>

          <div className="field">
            <label>Learning Mode</label>
            <div className="flex flex-column gap-2">
              {learningModes.map(mode => (
                <div key={mode} className="flex align-items-center">
                  <RadioButton
                    inputId={`mode-${mode}`}
                    name={`learningMode_${subtype}`}
                    value={mode}
                    checked={formState[`learningMode_${subtype}`] === mode}
                    onChange={(e) => setFormState(`learningMode_${subtype}`, e.value)}
                  />
                  <label htmlFor={`mode-${mode}`} className="ml-2">{mode}</label>
                </div>
              ))}
            </div>
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`certificate_${subtype}`}
                checked={formState[`certificateOffered_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`certificateOffered_${subtype}`, e.checked)}
              />
              <label htmlFor={`certificate_${subtype}`} className="ml-2">Certificate Offered</label>
            </div>
          </div>
        </>
      )}

      {/* Language Schools */}
      {subtype === 'ED_languageSchools' && (
        <>
          <div className="field">
            <label>Languages Offered</label>
            <InputText
              value={formState[`languagesOffered_${subtype}`] || ''}
              onChange={(e) => setFormState(`languagesOffered_${subtype}`, e.target.value)}
              placeholder="e.g. English, Spanish, French"
            />
          </div>

          <div className="field">
            <label>Age Group</label>
            <InputText
              value={formState[`ageGroup_${subtype}`] || ''}
              onChange={(e) => setFormState(`ageGroup_${subtype}`, e.target.value)}
              placeholder="e.g. Kids, Adults, All Ages"
            />
          </div>

          <div className="field">
            <label className="mr-2">Class Size</label>
            <InputNumber
              value={formState[`classSize_${subtype}`] || 0}
              onValueChange={(e) => setFormState(`classSize_${subtype}`, e.value)}
              placeholder="e.g. 10-15 students"
            />
          </div>
        </>
      )}

      {/* Workshops / Seminars */}
      {subtype === 'ED_workshops' && (
        <>
          <div className="field">
            <label>Workshop Topics</label>
            <InputText
              value={formState[`workshopTopics_${subtype}`] || ''}
              onChange={(e) => setFormState(`workshopTopics_${subtype}`, e.target.value)}
              placeholder="e.g. Leadership, Personal Development"
            />
          </div>

          <div className="field">
            <label className="mr-2">Session Duration (hrs)</label>
            <InputNumber
              value={formState[`sessionDuration_${subtype}`] || 0}
              onValueChange={(e) => setFormState(`sessionDuration_${subtype}`, e.value)}
              placeholder="e.g. 2 hours, 3 hours"
            />
          </div>

          <div className="field">
            <label>Instructor Information</label>
            <InputText
              value={formState[`instructorInfo_${subtype}`] || ''}
              onChange={(e) => setFormState(`instructorInfo_${subtype}`, e.target.value)}
              placeholder="e.g. John Doe, Expert in Communication"
            />
          </div>
        </>
      )}
    </div>
  );
}
